import { useQuery } from "@tanstack/react-query"
import * as learnPracticeService from "../services/learnPractice.service"

export function useFeaturedRituals(limit: number = 5) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["featured-rituals", limit],
    queryFn: () => learnPracticeService.getFeaturedRituals(limit),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    rituals: data ?? [],
    isLoading,
    error,
  }
}
